import useConsent from '../../hooks/useConsent/index.js';
import React, { useState, useEffect } from 'react';

const inlinePixelJs = pinTagId => `!function(e){if(!window.pintrk){window.pintrk=function(){
  window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var n=window.pintrk;n.queue=[],n.version="3.0";var t=document.createElement("script");t.async=!0,t.src=e;var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");pintrk('load','${pinTagId}',{em: '<user_email_address>'});pintrk('page');`; // eslint-disable-line max-len

function PinterestPixel(_ref) {
  let {
    pinTagId
  } = _ref;
  const [pixelAdded, setPixelAdded] = useState(false);
  const {
    consentValue,
    isConsentReady
  } = useConsent('tracking');
  useEffect(() => {
    if (consentValue && !pixelAdded) {
      const headScript = document.createElement('script');
      headScript.type = 'text/javascript';
      headScript.textContent = inlinePixelJs(pinTagId);
      document.head.appendChild(headScript);
      setPixelAdded(true);
    }
  }, [consentValue, isConsentReady, pinTagId, pixelAdded]);
  return consentValue && /*#__PURE__*/React.createElement("noscript", null, /*#__PURE__*/React.createElement("img", {
    height: "1",
    width: "1",
    style: {
      display: 'none'
    },
    alt: "",
    src: `https://ct.pinterest.com/v3/?event=init&tid=${pinTagId}&pd[em]=<hashed_email_address>&noscript=1`
  }));
}

export { PinterestPixel as default };
